/** Main project script */



// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

// main code
so.app = {
    init: function () {
        this.toggleNavigation();
        this.searchPopoverTrigger();
        this.toggleSubNavigation();
    },
    toggleNavigation() {
        $(".nav-main-trigger").click(function(e) {
            e.preventDefault();

            so.app.closeSearchPopover();

            $(".nav-main").toggleClass('nav-main-open');
        });
    },
    toggleSubNavigation() {
        $(".nav-main-sub-menu-trigger").click(function() {
            var target = $(this).attr('data-target');

            if ($(this).attr('aria-expanded') === 'true') {
                $(this).attr('aria-expanded', 'false');
            } else {
                $(this).attr('aria-expanded', 'true');
            }

            $(target).toggleClass('nav-main-sub-menu-open');
        });
    },
    closeMegaMenu() {
        $(".nav-main").removeClass('nav-main-open');
        $(".mega-menu").removeClass('open');
    },
    closeSearchPopover() {
        $(".nav-main").removeClass('search-popover-open');
        $(".search-popover").removeClass('open');
    },
    searchPopoverTrigger() {
        $(".search-popover-trigger").click(function(e) {
            e.preventDefault();

            so.app.closeMegaMenu();

            $(".nav-main").toggleClass('search-popover-open');
            $(".search-popover").toggleClass('open');
            // $(".search-popover form").toggle();
        });
    },
};

$(document).ready(function () {
    so.app.init();
});



// WEBPACK FOOTER //
// ./javascript/src/main.js